module.exports = "<div class=\"container-fluid m-0 p-0\">\n    <div class=\"row no-gutters\">\n        <div class=\"col-12\">\n            <app-header></app-header>\n        </div>\n        <div class=\"col-12\">\n            <router-outlet></router-outlet>\n        </div>\n        <div class=\"col-12\">\n            <app-fotter></app-fotter>\n        </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/pgutev/work/WEBCAM/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main